import { MaintenancePanel } from './MaintenancePanel';

/**
 * Écran mobile confié à une intervenante (ex. Aurélie) via un lien temporaire.
 * Même contenu que l'onglet Entretien de l'administration, mais sur les
 * routes `/api/maintenance/*` et sans le bloc de gestion des liens ni le
 * bouton d'annulation d'une réparation.
 */
export function MaintenanceMission({ onLogout }: { onLogout: () => Promise<void> }) {
  return (
    <div className="mission-shell">
      <header className="mission-header">
        <div className="mission-header-main">
          <div><p className="eyebrow">Accès temporaire</p><h1>Entretien</h1></div>
          <button className="text-button light" onClick={() => void onLogout()}>Quitter</button>
        </div>
      </header>
      <main className="mission-body">
        <MaintenancePanel
          basePath="/api/maintenance/conditions"
          allowReopen={false}
          showAccessLink={false}
          canReport
        />
      </main>
    </div>
  );
}
